"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layoutConstants = exports.PersonalDetailsAvatarDefaultProps = exports.PHONE_TOOL_URL = exports.INVERTED_COLOR_SCHEME = exports.DEFAULT_COLOR_SCHEME = exports.COMPONENT_USERNAME_ID = exports.COMPONENT_USERNAME = exports.COMPONENT_PRONOUNS_ID = exports.COMPONENT_PRONOUNS = exports.COMPONENT_IMAGE_ID = exports.COMPONENT_FULL_NAME_ID = exports.COMPONENT_FULL_NAME = exports.COMPONENT_ALTERNATE_NAME_ID = exports.COMPONENT_ALTERNATE_NAME = exports.BADGE_PHOTO_URL = exports.AvatarDefaultProps = exports.AvatarBadgeColor = exports.AVATAR_NOCLIPPING_NAME_LINE_HEIGHT = exports.AVATAR_NAME_LINE_DATA_TEST_COMPONENT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interfaces = require("./interfaces");

var _layoutConstants;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var layoutConstants = (_layoutConstants = {}, (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.ExtraSmall, {
  imageSize: 24,
  imageSpacing: 8,
  nameFontSize: 'T100',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 0,
  maxChildren: 0,
  borderRadius: 'R100',
  badgeBorderWidth: 2
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.Small, {
  imageSize: 32,
  imageSpacing: 8,
  nameFontSize: 'T200',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 4,
  maxChildren: 1,
  borderRadius: 'R100',
  badgeBorderWidth: 3
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.Medium, {
  imageSize: 48,
  imageSpacing: 16,
  nameFontSize: 'T200',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 3,
  maxChildren: 2,
  borderRadius: 'R100',
  badgeBorderWidth: 4
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.DietLarge, {
  imageSize: 80,
  imageSpacing: 16,
  nameFontSize: 'T200',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 8,
  maxChildren: 3,
  borderRadius: 'R300',
  badgeBorderWidth: 4
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.Large, {
  imageSize: 112,
  imageSpacing: 24,
  nameFontSize: 'T400',
  nameFontWeight: 'regular',
  nameLineHeight: 1,
  textFontSize: 'T300',
  lineHeight: 1,
  spacing: 12,
  maxChildren: 3,
  borderRadius: 'R300',
  badgeBorderWidth: 4
}), _layoutConstants);
exports.layoutConstants = layoutConstants;
var DEFAULT_COLOR_SCHEME = {
  textColor: 'neutral100',
  linkColor: 'primary70',
  pronounColor: 'neutral70'
};
exports.DEFAULT_COLOR_SCHEME = DEFAULT_COLOR_SCHEME;
var INVERTED_COLOR_SCHEME = {
  textColor: 'neutral0',
  linkColor: 'primary30',
  pronounColor: 'neutral40'
};
exports.INVERTED_COLOR_SCHEME = INVERTED_COLOR_SCHEME;
var BADGE_PHOTO_URL = 'https://cdn.prod.badgephotos.side.amazon.dev/';
exports.BADGE_PHOTO_URL = BADGE_PHOTO_URL;
var AvatarBadgeColor;
exports.AvatarBadgeColor = AvatarBadgeColor;

(function (AvatarBadgeColor) {
  AvatarBadgeColor["Gold"] = "#8E5D00";
  AvatarBadgeColor["Silver"] = "#8B96A3";
  AvatarBadgeColor["Purple"] = "purple70";
  AvatarBadgeColor["Red"] = "red60";
  AvatarBadgeColor["Yellow"] = "#F4980A";
  AvatarBadgeColor["Blue"] = "primary50";
})(AvatarBadgeColor || (exports.AvatarBadgeColor = AvatarBadgeColor = {}));

var PHONE_TOOL_URL = 'https://phonetool.amazon.com/users/';
exports.PHONE_TOOL_URL = PHONE_TOOL_URL;
var COMPONENT_FULL_NAME = 'AvatarFullname';
exports.COMPONENT_FULL_NAME = COMPONENT_FULL_NAME;
var COMPONENT_ALTERNATE_NAME = 'AvatarAlternateName';
exports.COMPONENT_ALTERNATE_NAME = COMPONENT_ALTERNATE_NAME;
var COMPONENT_PRONOUNS = 'AvatarPronouns';
exports.COMPONENT_PRONOUNS = COMPONENT_PRONOUNS;
var COMPONENT_USERNAME = 'AvatarUsername';
exports.COMPONENT_USERNAME = COMPONENT_USERNAME;
var COMPONENT_FULL_NAME_ID = 'avatar-fullname';
exports.COMPONENT_FULL_NAME_ID = COMPONENT_FULL_NAME_ID;
var COMPONENT_ALTERNATE_NAME_ID = 'avatar-alternate-name';
exports.COMPONENT_ALTERNATE_NAME_ID = COMPONENT_ALTERNATE_NAME_ID;
var COMPONENT_PRONOUNS_ID = 'avatar-pronouns';
exports.COMPONENT_PRONOUNS_ID = COMPONENT_PRONOUNS_ID;
var COMPONENT_USERNAME_ID = 'avatar-username';
exports.COMPONENT_USERNAME_ID = COMPONENT_USERNAME_ID;
var COMPONENT_IMAGE_ID = 'avatar-image';
exports.COMPONENT_IMAGE_ID = COMPONENT_IMAGE_ID;
var AvatarDefaultProps = {
  size: _interfaces.AvatarSize.Medium,
  showImage: true,
  isUsernameClickable: true,
  newTabHiddenText: 'opens in a new tab or new window',
  showUsername: true,
  colorScheme: _interfaces.AvatarColorScheme.Default,
  showFullName: true
};
exports.AvatarDefaultProps = AvatarDefaultProps;

var PersonalDetailsAvatarDefaultProps = _objectSpread(_objectSpread({}, AvatarDefaultProps), {}, {
  businessTitleHiddenText: 'business title',
  departmentHiddenText: 'department',
  locationHiddenText: 'location'
});

exports.PersonalDetailsAvatarDefaultProps = PersonalDetailsAvatarDefaultProps;
var AVATAR_NOCLIPPING_NAME_LINE_HEIGHT = 1.1;
exports.AVATAR_NOCLIPPING_NAME_LINE_HEIGHT = AVATAR_NOCLIPPING_NAME_LINE_HEIGHT;
var AVATAR_NAME_LINE_DATA_TEST_COMPONENT = 'AvatarNameLine';
exports.AVATAR_NAME_LINE_DATA_TEST_COMPONENT = AVATAR_NAME_LINE_DATA_TEST_COMPONENT;